export default __webpack_public_path__ + "static/media/Goose-NFT-Preview.bf060fcd.gif";